import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import useChannelStore from '@/stores/ChannelStore';
import Heading from '../Heading';
import ChatWindow from '../giveaways/ChatWindow';
import GiveawayPanel from '../giveaways/GiveawayPanel';
import { Helmet } from 'react-helmet';
import styles from './Giveaway.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { Divider } from '@mantine/core';
export default function Giveaways() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var intl = useIntl();
    if (channel == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        footerProps: {
            className: styles.giveawayFooter
        },
        containerProps: {
            className: styles.giveawayLayoutContainer
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "hD43nJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Giveaway"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.giveawayHeading,
                subHeading: intl.formatMessage({
                    id: "yEmyS/",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Create and manage giveaways."
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "hD43nJ",
                    defaultMessage: "Giveaway"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.giveawayContainer,
                children: [
                    /*#__PURE__*/ _jsx(GiveawayPanel, {
                        className: styles.giveawayPanel
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        orientation: "vertical",
                        className: styles.giveawayDivider
                    }),
                    /*#__PURE__*/ _jsx(ChatWindow, {
                        className: styles.chatWindow,
                        channel: channel
                    })
                ]
            })
        ]
    });
}
